import { ALL_PLANS_BY_SKU } from 'app/views/plans/PlansData'

// The plan a Free customer is offered for a custom-selection Kit: Solo when the
// selection needs something only Solo has (Pro+ icons, Kit packages), else Starter.
// Shared by the icon selection bar and the Kit wizard so both land on the same page.
export function kitOfferPlanSlug(needsSolo) {
  return needsSolo ? 'solo' : 'starter'
}

// CONTENT-06: purchasable means on the allow-list, not merely absent from the deny-list.
export function isPurchasablePlan(plan) {
  return !!plan && ALL_PLANS_BY_SKU.includes(plan.sku)
}

export function kitOfferPlanRoute({ needsSolo, getPlanBySlug }) {
  const slug = kitOfferPlanSlug(needsSolo)

  // CONTENT-06: never send someone to a plan they can't buy.
  if (!isPurchasablePlan(getPlanBySlug(slug))) return { name: 'plans' }

  return { name: `plans.${slug}` }
}
